import * as React from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import PinterestIcon from '@mui/icons-material/Pinterest';
import PhoneIphone from '@mui/icons-material/PhoneIphone';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Link,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Button,
  Grid
} from '@mui/material';

import HelpIcon from '@mui/icons-material/Help';
import { NavLink } from '../../model';

export interface HelpMenuProps {
  links?: NavLink[];
  phone?: string;
  onLoading?: (loading: boolean) => void;
}

export function HelpMenu(props: HelpMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuClick = () => {
    setAnchorEl(null);

    if (props.onLoading) {
      props.onLoading(true);
    }
  };

  return (
    <>
      <Box sx={{ pl: 1 }}>
        <IconButton id="help-button" aria-label="more" color="inherit" onClick={handleClick}>
          <HelpIcon />
        </IconButton>
        <Menu
          id="help-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'help-button'
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
        >
          <ListItem divider button={false}>
            <ListItemAvatar>
              <Avatar>
                <PhoneIphone />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Travel Advisors Only"
              secondary={
                <Button
                  href={`tel:${props.phone}`}
                  sx={{
                    color: 'inherit'
                  }}
                >
                  {props.phone}
                </Button>
              }
            />
          </ListItem>

          {props.links &&
            props.links.map((link, index) => (
              <MenuItem
                key={link.id}
                component={Link}
                href={link.path}
                onClick={handleMenuClick}
                divider={index == (props.links && props.links.length - 1)}
              >
                {link.text}
              </MenuItem>
            ))}
          <ListItem component="div" sx={{ textAlign: 'center' }}>
            <Grid container>
              <Grid item xs>
                <IconButton size="small" onClick={handleMenuClick} href="https://www.facebook.com/ClassicVacations/">
                  <FacebookIcon />
                </IconButton>
              </Grid>
              <Grid item xs>
                <IconButton size="small" onClick={handleMenuClick} href="https://twitter.com/classicvacation">
                  <TwitterIcon />
                </IconButton>
              </Grid>
              <Grid item xs>
                <IconButton
                  size="small"
                  onClick={handleMenuClick}
                  href="https://www.instagram.com/weareclassicvacations/"
                >
                  <InstagramIcon />
                </IconButton>
              </Grid>
              <Grid item xs>
                <IconButton
                  size="small"
                  onClick={handleMenuClick}
                  href="https://www.linkedin.com/company/classic-vacations"
                >
                  <LinkedInIcon />
                </IconButton>
              </Grid>
              <Grid item xs>
                <IconButton size="small" onClick={handleMenuClick} href="https://www.pinterest.com/classicvacation/">
                  <PinterestIcon />
                </IconButton>
              </Grid>
            </Grid>
          </ListItem>
        </Menu>
      </Box>
    </>
  );
}
